import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { AuthGuard } from './_guards';
import { NewuserComponent } from './user/newuser/newuser.component';
import { UserValidateComponent  } from './user/user-validate/user-validate.component'
import { ForgotpasswordComponent } from './user/forgotpassword/forgotpassword.component';
import { MarcComponent } from './marc/marc.component';
import { UserEditComponent } from './user/user/user-edit/user-edit.component';
import { UserCardComponent } from './user/user/user-card/user-card.component';
import { UserComponent } from './user/user/user.component';
import { ResetPasswordComponent } from './user/resetpassword/resetpassword.component';
import { UserUnsubscribeComponent } from './user/user/user-unsubscribe/user-unsubscribe.component';
import { SearchComponent } from './search/search.component';
import { CanDeactivateGuard } from './_guards/can-deactivate/can-deactivate.guard';
import { UserCouponsComponent } from './user/user/user-coupons/user-coupons.component';
import { UserOrdersComponent } from './user/user/user-orders/user-orders.component';
import { ProductsComponent } from './products/products/products.component';
import { UserAddressesComponent } from './user/user/user-addresses/user-addresses.component';
import { UserAppComponent } from './user/user/user-app/user-app.component';
import { Error404Component } from './static-pages/error404/error404.component';
import { ProductDetailComponent } from './products/product-detail/product-detail.component';
import { UserCartComponent } from './user/user-cart/user-cart.component';
import { CartPaymentErrorComponent } from './user/user-cart/cart-payment-error/cart-payment-error.component';
import { UserListComponent } from './user/user/user-list/user-list.component';
import { CartPaymentSuccessComponent } from './user/user-cart/cart-payment-success/cart-payment-success.component';
import { LegalWarningComponent } from './static-pages/legal-warning/legal-warning.component';
import { PrivacyPolicyComponent } from './static-pages/privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './static-pages/cookie-policy/cookie-policy.component';
import { PurchaseConditionsComponent } from './static-pages/purchase-conditions/purchase-conditions.component';
import { HowToBuyComponent } from './static-pages/how-to-buy/how-to-buy.component';
import { FaqsComponent } from './static-pages/faqs/faqs.component';
import { DeliveryZonesComponent } from './static-pages/delivery-zones/delivery-zones.component';
import { PaymentMethodsComponent } from './static-pages/payment-methods/payment-methods.component';
import { PromosComponent } from './promos/promos/promos.component';
import { PromoDetailComponent } from './promos/promo-detail/promo-detail.component';
import { WebPromosComponent } from './products/web-promos/web-promos.component';
import { DeliveryAxaComponent } from './header/delivery-axa/delivery-axa.component';

const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'user',
    canActivate:  [AuthGuard],
    component: UserComponent,
    children: [
      {path: '', redirectTo: 'edit' , pathMatch: 'full'},
      {path: 'edit', component: UserEditComponent, canDeactivate: [CanDeactivateGuard]},
      {path: 'addresses', component: UserAddressesComponent, canDeactivate : [CanDeactivateGuard]},
      {path: 'card', component: UserCardComponent },
      {path: 'coupons', component: UserCouponsComponent },
      {path: 'list/:listId', component: UserListComponent },
      {path: 'app', component: UserAppComponent },
      {path: 'orders/open', component: UserOrdersComponent },
      {path: 'orders/closed', component: UserOrdersComponent },
      {path: 'unsubscribe', component: UserUnsubscribeComponent},
    ]
  },
  {
    path: 'user/cart',
    canActivate:  [AuthGuard],
    component: UserCartComponent,
  },
  {
    path: 'user/cart/payment-error',
    canActivate:  [AuthGuard],
    component: CartPaymentErrorComponent,
  },
  {
    path: 'user/cart/payment-success',
    canActivate:  [AuthGuard],
    component: CartPaymentSuccessComponent,
  },
  {
    path: 'promos/:categoryId',
    canActivate:  [AuthGuard],
    component: PromosComponent
  },
  {
    path: 'promo/:categoryId',
    canActivate:  [AuthGuard],
    component: PromoDetailComponent
  },
  {
    path: 'products/:categoryId',
    canActivate:  [AuthGuard],
    component: ProductsComponent
  },
  {
    path: 'product-detail/:itemId',
    canActivate:  [AuthGuard],
    component: ProductDetailComponent
  },
  {
    path: 'search',
    canActivate:  [AuthGuard],
    component: SearchComponent
  },
  {
    path: 'user/newuser',
    component: NewuserComponent
  },
  {
    path: 'user/validate/:id_user/:guid',
    component: UserValidateComponent
  },
  {
    path: 'user/forgotpassword',
    component: ForgotpasswordComponent
  },
  {
    path: 'user/resetpassword/:id_user/:guid',
    component: ResetPasswordComponent
  },
  {
    path: 'user/cancelpasswordrecovery/:id_user/:guid',
    component: ResetPasswordComponent
  },
  {
    path: 'legal-warning',
    component: LegalWarningComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'cookie-policy',
    component: CookiePolicyComponent
  },
  {
    path: 'purchase-conditions',
    component: PurchaseConditionsComponent
  },
  {
    path: 'how-to-buy',
    component:HowToBuyComponent
  },
  {
    path: 'faqs',
    component:FaqsComponent
  },
  {
    path: 'delivery-zones',
    component:DeliveryZonesComponent
  },
  {
    path: 'payment-methods',
    component:PaymentMethodsComponent
  },
  {
    path: 'error404',
    component: Error404Component
  },
  {
    path: 'OfertaWeb',
    component: WebPromosComponent
  },
  //20250602 axa inici
  {
    path: 'login/deliveryAxA',
    component: DeliveryAxaComponent
  },
  //20250602 axa final
  {
    path: 'marc',
    component: MarcComponent
  },
  // otherwise redirect to 404
  { path: '**', component: Error404Component }
];

export const routing = RouterModule.forRoot(appRoutes, { onSameUrlNavigation : 'reload', scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'});

//export const routing = RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled'});
